// extracted by mini-css-extract-plugin
module.exports = {"logo":"shopLogo_logo__RFCaX"};